import React from 'react';
import CtaLink from './CtaLink';
import AnimatedWords from './AnimatedWords';

const Hero = () => {
  return (
    <section id="home" className="hero relative w-full h-screen overflow-hidden">
      {/* 🔹 Background video */}
      <video
        className="absolute top-0 left-0 w-full h-full object-cover"
        src="/images/homepage_background.mp4"
        autoPlay
        loop
        muted
        playsInline
      />

      {/* 🔹 Black overlay with 0.3 opacity */}
      <div className="absolute inset-0 bg-black/70 z-[1]" />

      {/* 🔹 Foreground content */}
      <div className="relative z-[2] container hero-inner flex flex-col justify-center items-center lg:items-start text-white h-full">
        <h1 className="text-4xl md:text-6xl lg:text-[79px]">
          <AnimatedWords lines={["Fast, Reliable, and", "Timeless in service."]} />
        </h1>

        <div className="flex flex-col gap-10 lg:gap-0 lg:flex-row items-center lg:justify-between w-full">
          <div className="hero-content-row">
            <p className="lead text-lg md:text-xl lg:text-2xl">
              <AnimatedWords lines={["Reliable transport. Real-time tracking.", "Tailored logistics for your business."]} />
            </p>
          </div>
          <CtaLink href="#services" primaryText="Explore Our Services" ariaLabel="Scroll to services" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
